import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=fd4dfe60&scoped=true&"
import script from "./CloseButton.vue?vue&type=script&lang=ts&"
export * from "./CloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=fd4dfe60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4dfe60",
  null
  
)

export default component.exports